//SalesSearchSettings.ts ==============================================================

// ==================== Previous Sales Points Field Names =================
//Created_Da(type: esriFieldTypeDate, alias: 99! Created_Da, length: 8)
//CreatedByR(type: esriFieldTypeString, alias: 99! CreatedByR, length: 200)
//RetiredByR(type: esriFieldTypeString, alias: 99! RetiredByR, length: 200)
//StatedArea(type: esriFieldTypeDouble, alias: 99! StatedArea)
//TaxYear(type: esriFieldTypeString, alias: 99! TaxYear, length: 25)
//OBJECTID(type: esriFieldTypeOID, alias: FID)
//SALEKEY(type: esriFieldTypeInteger, alias: SALEKEY)
//GRANTEE(type: esriFieldTypeString, alias: GRANTEE, length: 205)
//GRANTOR(type: esriFieldTypeString, alias: GRANTOR, length: 205)
//SALEDATE(type: esriFieldTypeDate, alias: SALEDATE, length: 8)
//DEEDPAGE(type: esriFieldTypeString, alias: DEEDPAGE, length: 20)
//PLATPAGE(type: esriFieldTypeString, alias: PLATPAGE, length: 80)
//SALEPRICE(type: esriFieldTypeInteger, alias: SALEPRICE)
//SALECLASS(type: esriFieldTypeString, alias: SALECLASS, length: 1)
//STRAT(type: esriFieldTypeString, alias: STRAT, length: 1)
//STRATYPE(type: esriFieldTypeString, alias: STRATYPE, length: 8)
//SALES_MKTV(type: esriFieldTypeDouble, alias: SALES_MKTV)
//REASONCODE(type: esriFieldTypeString, alias: REASONCODE, length: 2)
//REASON(type: esriFieldTypeString, alias: REASON, length: 40)
//SALEQUAL(type: esriFieldTypeString, alias: SALEQUAL, length: 15)
//SALETYPE(type: esriFieldTypeString, alias: SALETYPE, length: 20)
//SALES_COMM(type: esriFieldTypeString, alias: SALES_COMM, length: 254)
//PIN(type: esriFieldTypeString, alias: PIN, length: 30)
//NEIGHBHOOD(type: esriFieldTypeString, alias: NEIGHBHOOD, length: 50)
//PROPERTY_T(type: esriFieldTypeString, alias: PROPERTY_T, length: 4)
//PROPDESC(type: esriFieldTypeString, alias: PROPDESC, length: 50)
//SUBD_NAME(type: esriFieldTypeString, alias: SUBD_NAME, length: 40)
//STREET_NAM(type: esriFieldTypeString, alias: STREET_NAM, length: 50)
//GARAGE(type: esriFieldTypeString, alias: GARAGE, length: 4)
//GRADE(type: esriFieldTypeString, alias: GRADE, length: 3)
//YR_BUILT(type: esriFieldTypeSmallInteger, alias: YR_BUILT)
//EXWALLTYPE(type: esriFieldTypeString, alias: EXWALLTYPE, length: 30)
//FULLBATHS(type: esriFieldTypeDouble, alias: FULLBATHS)
//HALFBATHS(type: esriFieldTypeDouble, alias: HALFBATHS)
//NO_BEDRMS(type: esriFieldTypeDouble, alias: NO_BEDRMS)
//NO_ROOMS(type: esriFieldTypeDouble, alias: NO_ROOMS)
//OBCONDTYPE(type: esriFieldTypeString, alias: OBCONDTYPE, length: 40)
//SITEADDRES(type: esriFieldTypeString, alias: SITEADDRES, length: 254)
//BASEMENT(type: esriFieldTypeDouble, alias: BASEMENT)
//LOTSIZE(type: esriFieldTypeDouble, alias: LOTSIZE)
//STRUCTSIZE(type: esriFieldTypeDouble, alias: STRUCTSIZE)
//MKT_VAL(type: esriFieldTypeDouble, alias: MKT_VAL)
//OCCUPANCY(type: esriFieldTypeString, alias: OCCUPANCY, length: 40)
//VACANT(type: esriFieldTypeString, alias: VACANT, length: 3)
//Shape(type: esriFieldTypeGeometry, alias: 99! Shape)
//================================================================

import "../Util/Prototypes";

//ESRI javascript API.
import SimpleFillSymbol from "@arcgis/core/symbols/SimpleFillSymbol";

export interface iPropType {
   name: string;
   layerName: string;
   where: string;
   image1: string;
   criteriaKeys: string[];
}

export interface iOmitImproveTypeCriteria {
   improveType: string;
   criteriaKeys: string[];
}

export interface iCriteria {
   field: string;
   subjectField: string;
   rangePercent: number;
   weighting: number;
   convertSubjectToAcres?: boolean;
   convertSalesToAcres?: boolean;
   alias: string;
   subjectValue?: number;
   minValue?: number;
   maxValue?: number;
}

export interface iCriteriaDropdown {
   field: string;
   alias: string;
   values: string[];
   value: string;
   defaultValue: string;
}

export interface iSaleDate {
   field: string;
   alias: string;
   weighting: number;
}

export interface iImproveType {
   name: string;
   vacant?: boolean;
   where: string;
}

export interface iSubjectField {
   pin: string;
   propdesc: string;
   siteaddress: string;
   yr_built: string;
   no_bedrms: string;
   fullbaths: string;
   halfbaths: string;
   subdivision: string;
   exwalltype: string;
   garage: string;
   basement: string;
   saleprice: string;
   saletype: string;
   structsize: string;
   lotsize: string;
   subd_name: string;
   neighbhood_desc: string;
   occupancy: string;
}

export interface iSS {
   propTypes: iPropType[];
   propertyTypes: string[];
   improveTypes: iImproveType[];
   improvementTypes: string[];
   omitImproveTypeCriterias: iOmitImproveTypeCriteria[];
   omitVacantFields: string[];

   StructureSize: iCriteria;
   BasementSqFt: iCriteria;
   LotSize: iCriteria;
   YearBuilt: iCriteria;
   Bedrooms: iCriteria;
   Bathrooms: iCriteria;
   Condition: iCriteria;
   Quality: iCriteria;
   SalePrice: iCriteria;

   HouseStyle: iCriteriaDropdown;
   ExteriorMaterial: iCriteriaDropdown;
   Garage: iCriteriaDropdown;
   Grade: iCriteriaDropdown;
   BizType: iCriteriaDropdown;
   OnLake: iCriteriaDropdown;
   SaleType: iCriteriaDropdown;

   saleDate: iSaleDate;
   saleDate_spans: string[];
   distanceWeighting: number;
   subjectCentroid: __esri.Point;
   salesPointsMapTheme: string;

   autoSearch: boolean;
   neighborhood_layerName: string;
   geomSym: __esri.SimpleFillSymbol;

   subjectField_PropType: string;
   subjectField_ImproveType: string;

   subjectField: iSubjectField;
   accessLevel: number;
   accessLevel_neighborhood: number;
   accessLevel_salesAverage: number;
   accessLevel_report: number;
   searchRadius_list: string[];
   salesResultsTools: string[];
   salesResultsMoreTools: string[];
}

export const ss = {} as iSS; //Weird syntax.
const s: iSS = ss;

// Property type settings. Custom!
// Symbols: https://developers.arcgis.com/net/store/api-reference/html/6a641604-55f8-4173-88ce-9d0c9791db24.htm
// Format: Property_Type_Value, LayerName, Where_SQL, Icon_Image, Case_Sensitive_Criteria_Keys...
s.propTypes = [
   {
      name: "Any", layerName: "All Sales", where: "", image1: "Shapes/YellowCircleLargeB.png",
      criteriaKeys: ["StructureSize", "BasementSqFt", "LotSize", "YearBuilt", "Bedrooms", "Bathrooms", "Quality", "SalePrice", "HouseStyle", "ExteriorMaterial", "Garage", "Grade", "SaleType"]
   },
   {
      name: "Residential", layerName: "Residential", where: "PropDesc like 'Residential%'", image1: "PeoplePlaces/Housing.png",
      criteriaKeys: ["StructureSize", "BasementSqFt", "LotSize", "YearBuilt", "Bedrooms", "Bathrooms", "Quality", "SalePrice", "HouseStyle", "ExteriorMaterial", "Garage", "Grade", "SaleType"]
   },
   {
      name: "Commercial", layerName: "Commercial", where: "PropDesc like 'Commercial%'", image1: "PeoplePlaces/City.png",
      criteriaKeys: ["StructureSize", "LotSize", "YearBuilt", "SalePrice", "SaleType"]
   },
   {
      name: "Industrial", layerName: "Industrial", where: "PropDesc like 'Industrial%'", image1: "PeoplePlaces/City.png",
      criteriaKeys: ["StructureSize", "LotSize", "YearBuilt", "SalePrice", "SaleType"]
   },
   {
      name: "Agricultural", layerName: "Agricultural", where: "PropDesc like 'Agricultural%'", image1: "PeoplePlaces/Forest.png",
      criteriaKeys: ["LotSize", "SalePrice", "SaleType"]
   },
   {
      name: "Historic", layerName: "Historic", where: "PropDesc like 'Historic%'", image1: "PeoplePlaces/Housing.png",
      criteriaKeys: ["StructureSize", "BasementSqFt", "LotSize", "YearBuilt", "Bedrooms", "Bathrooms", "Quality", "SalePrice", "HouseStyle", "ExteriorMaterial", "Garage", "Grade", "SaleType"]
   },
   {
      name: "Public Utility", layerName: "Public Utility", where: "PropDesc like 'Utility%'", image1: "PeoplePlaces/City.png",
      criteriaKeys: ["StructureSize", "LotSize", "YearBuilt", "SalePrice", "SaleType"]
   },
   {
      name: "Exempt", layerName: "Exempt", where: "PropDesc like 'Exempt%'", image1: "PeoplePlaces/Housing.png",
      criteriaKeys: ["StructureSize", "LotSize", "YearBuilt", "SalePrice", "SaleType"]
   },
   //   {
   //      name: "Preferential Covenant", layerName: "Preferential Covenant", where: "PropDesc = 'Preferential Covenant'", image1: "PeoplePlaces/Housing.png",
   //      criteriaKeys: ["StructureSize", "LotSize", "YearBuilt", "SalePrice", "SaleType"]
   //   },
   {
      name: "Conservation Covenant", layerName: "Conservation Covenant", where: "PropDesc like 'Conservation%'", image1: "PeoplePlaces/Housing.png",
      criteriaKeys: ["StructureSize", "LotSize", "YearBuilt", "SalePrice", "SaleType"]
   },
];

s.propertyTypes = [];
for (const propType of s.propTypes) {
   s.propertyTypes.push(propType.name);
}

//Improvement types ("name" value is case sensitive). Building with Land, Land Only, Building Only.
s.improveTypes = [{ name: "Any", where: "" },
   { name: "Land With Building", vacant: false, where: "SaleType = 'Land With Building'" },
   { name: "Land only", vacant: true, where: "SaleType = 'Land only'" },
   { name: "Building only", vacant: false, where: "SaleType = 'Building only'" }
];

s.improvementTypes = [];
for (const improveType of s.improveTypes) {
   s.improvementTypes.push(improveType.name);
}

//Omit search criteria based on sale type. Format: Sale_Type_Value, Criteria_Keys_To_Omit...
s.omitImproveTypeCriterias = [
   { improveType: "Land only", criteriaKeys: ["StructureSize", "BasementSqFt", "YearBuilt", "Bedrooms", "Bathrooms", "Quality", "HouseStyle", "ExteriorMaterial", "Garage", "Grade"] },
   { improveType: "Building only", criteriaKeys: ["LotSize"] }
];

//Omit display fields for vacant properties.
s.omitVacantFields = ["StructSize", "Basement", "Yr_Built", "No_Bedrms", "FullBaths", "Grade", "Occupancy", "ExWallType", "Garage", "obCondType"];

// Case sensitive range criteria Keys and sales field names.  Subject field names are not case sensitive.
// Percent offset is for pre-popluating ranges from subject values.
// Set percent to -1 to not initialize range search.
// Weighting values are 1 to 5
// Format: Criteria_Key = Sales_Field, subject_Property_Field, alias_prompt, Percent offset, Weighting
s.StructureSize = { field: "structsize", subjectField: "StructSize", alias: "Structure SqFt", rangePercent: 50, weighting: 5 };
s.BasementSqFt = { field: "basement", subjectField: "Basement", alias: "Basement SqFt", rangePercent: -1, weighting: 2 };
s.LotSize = { field: "lotsize", subjectField: "TotalAcres", alias: "Lot Size (acres)", convertSubjectToAcres: false, convertSalesToAcres: false, rangePercent: 450, weighting: 2 };
s.YearBuilt = { field: "yr_built", subjectField: "Yr_Built", alias: "Year Built", rangePercent: 2, weighting: 2 };
s.Bedrooms = { field: "no_bedrms", subjectField: "No_Bedrooms", alias: "Bedrooms", rangePercent: 100, weighting: 1 };
s.Bathrooms = { field: "fullbaths", subjectField: "FullBaths", alias: "Bathrooms", rangePercent: -1, weighting: 1 };
s.Quality = { field: "grade", subjectField: "Grade", alias: "Quality", rangePercent: -1, weighting: 1 };
s.SalePrice = { field: "saleprice", subjectField: "Curr_Val", alias: "Market & Sale Price", rangePercent: 50, weighting: 0 };

//Drop-down list criterial.
s.HouseStyle = { field: "Occupancy", alias: "Occupancy", values: ["Any", "Apartment", "Mobile Homes", "One Family", "Two Family", "Three Family"], value: "Any", defaultValue: "Any" };
s.ExteriorMaterial = { field: "ExWallType", alias: "Exterior Material", values: ["Any", "Wood Siding", "Stucco", "Brick Veneer (Face)", "Stone Veneer", "Concrete Veneer", "Common Brick", "Stucco Front/Vinyl Siding", "Vinyl/Alum Siding", "Rustic Log", "HardiPlank Siding Cement Fiber", "Plywood/Hardboard Siding", "Brick/Vinyl (half & half)", "Brick/Wood (half & half)", "Other"], value: "Any", defaultValue: "Any" };
s.Garage = { field: "Garage", alias: "Garage", values: ["Any", "yes", "no"], value: "Any", defaultValue: "Any" };
s.Grade = { field: "ObCondType", alias: "Condition", values: ["Any", "Poor", "Fair", "Average", "Good", "Excellent"], value: "Any", defaultValue: "Any" };
s.SaleType = { field: "SaleQual", alias: "Sale Type", values: ["Any", "Qualified", "Unqualified"], value: "Qualified", defaultValue: "Qualified" };

//Sale date. Case sensitive field name.
s.saleDate = { field: "saledate", alias: "Sale Date", weighting: 1 };
s.saleDate_spans = ["Custom", "1 Month", "3 Months", "6 Months", "9 Months", "1 Year", "2 Years", "3 Years", "4 years", "5 Years", "10 Years"];

//Distance from subject property weighting.
s.distanceWeighting = 2;
s.subjectCentroid = null;

//Sales points map theme must have the first property type layer name in it.
s.salesPointsMapTheme = "Sales Points";

//Neighborhood polygon layer.
s.neighborhood_layerName = "Subdivision for Sales Search";
s.geomSym = new SimpleFillSymbol({ color: [0, 0, 0, 0], style: "solid", outline: { color: [0, 180, 255, 1], width: 2 } });

//Property type and improvement type parcel fields to build dropdowns.
s.subjectField_PropType = "PropDesc";
s.subjectField_ImproveType = "Vacant";

//Subject parcel fields for comp report. Format: s.subjectField.lowercase_sales_field_name_here = "parcel_field_name_here";
s.subjectField = {} as iSubjectField; //Weird syntax.

s.subjectField.pin = "pin";
s.subjectField.propdesc = "PropDesc";
s.subjectField.siteaddress = "SiteAddress";
s.subjectField.yr_built = "Yr_Built";
s.subjectField.no_bedrms = "No_Bedrooms";
s.subjectField.fullbaths = "FullBaths";
s.subjectField.halfbaths = "HalfBaths";
//s.subjectField.exwalltype = "";
//s.subjectField.garage = "";
s.subjectField.basement = "Basement";
s.subjectField.saleprice = "Curr_Val";
//s.subjectField.saletype = "";
s.subjectField.structsize = "StructSize";
s.subjectField.lotsize = "TotalAcres";
s.subjectField.subd_name = "Subd_Name";
s.subjectField.neighbhood_desc = "Neighbhood_Desc";
//s.subjectField.occupancy = "";

//Immediately search for sales when a menu item has changed.
s.autoSearch = false;

// Access levels.
s.accessLevel = 0; //Overall access level.
s.accessLevel_neighborhood = 0;
s.accessLevel_salesAverage = 7;
s.accessLevel_report = 7;

// Sales search radiuses.
s.searchRadius_list = ["Any", "0.25", "0.5", "1", "2", "3", "4", "5", "6", "7", "8", "9", "10", "20"];

s.salesResultsTools = ["Zoom all", "Clear"];
s.salesResultsMoreTools = ["Comp Report", "Heat Map", "CSV"]; // "Table View", Add a leading blank space to comment out tools.

//Get property type spec.
export function getPropTypeSpec(name: string): iPropType {
   for (const propType of s.propTypes) {
      if (propType.name === name) {
         return propType;
      }
   }
   return null;
}
//Get improvement type spec.
export function getImproveTypeSpec(name: string): iImproveType {
   for (const improveType of s.improveTypes) {
      if (improveType.name === name) {
         return improveType;
      }
   }
   return null;
}

//Get omit improvement type spec.
export function getOmitImproveTypeSpec(improveType: string): iOmitImproveTypeCriteria {
   for (const omitCriteria of s.omitImproveTypeCriterias) {
      if (omitCriteria.improveType === improveType) {
         return omitCriteria;
      }
   }
   return null;
}
